
import {Component, Prop, Vue} from 'vue-property-decorator';
@Component
export default class ModalPayrollAccounting extends Vue {
    @Prop() readonly form!: any;

}
